import cookieData from "../cookie-data";

function init(element) {
    const $wrap = $('[data-tariff-locality]');
    const $body = $('body');
    const $locality = $(element).find('[name="locality"]');
    const $region = $(element).find('[name="region"]');
    const $localityLists = $(element).find('[data-locality-lists]');

    let pageSize = cookieData.receive('localitySize') || 12;
    let currentPage = 1;
    let tariffsList = '';
    let cityList = [];
    let regionList = [];
    let localityValue = '';
    let regionValue = '';
    const translates = window.translates.tariffLocality;

    $(document).on('select2:select', '[name="localitySize"]', function () {
        const oldPageSize = pageSize;
        pageSize = parseInt($(this).val());
        currentPage = Math.ceil((oldPageSize * (currentPage - 1) + 1) / pageSize);
        setTarifList(tariffsList);
        cookieData.add('localitySize', $(this).val(), {expires: 3600 * 24 * 180, path: '/'});
    });

    $(document).on('click', '[data-page]:not(disabled)', function() {
        if ($(this).data('page') === 'prev') {
            currentPage--;
        } else if ($(this).data('page') === 'next') {
            currentPage++;
        } else {
            currentPage = $(this).data('page');
        }
        if ($localityLists.length > 0) {
            paginate($localityLists);
        }
    })


    $(document).on('select2:select', '[name="locality"]', function () {
        localityValue = $(this).val();
        $region.val(null).trigger('change');
        if(localityValue === '0') {
            setTarifList(tariffsList);
        } else {
            searchTariffLocality();
        }
    });

    $(document).on('select2:select', '[name="region"]', function () {
        regionValue = $(this).val();
        $locality.val(null).trigger('change');
        if(regionValue === '0') {
            setTarifList(tariffsList);
        } else {
            searchTariffRegion();
        }
    });


    function GetCityWithTarif() {
        $body.addClass('is-loading');
        $.ajax({
            url: '/' + window.currentLang + '/SharedForms/GetCityWithTarif',
            type: 'get',
            success: (response) => {
                tariffsList = response['cityWithTarifList'];
                cityList = response['cityList'].map((item) => {
                    return (`<option value="${item['Value']}">${item['Text']}</option>`)
                });
                regionList = response['regionList'].map((item) => {
                    return (`<option value="${item['Value']}">${item['Text']}</option>`)
                });

                setTarifList(tariffsList);
                setCityList(cityList);
                setRegionList(regionList);
                $body.removeClass('is-loading');
            }
        })
    }

    function searchTariffLocality() {
        let tariffLocality = tariffsList.filter((item) => {
            return item['cityId'] === localityValue;
        });
        setTarifList(tariffLocality);
    }

    function searchTariffRegion() {
        let tariffRegion = tariffsList.filter((item) => {
            return item['regionId'] === regionValue;
        });
        setTarifList(tariffRegion);
    }

    function setTarifList(data) {
        let tariff = data.map((item, index) => {
            return (`
                           <div class="tariffs__row _p-df _vw:p-df" data-item="${index + 1}">
                                    <div class="tariffs__col">
                                         <div class="text-14 _color-dark-gray">${item['cityName']}</div>
                                    </div>
                                    <div class="tariffs__col">
                                         <div class="text-14 _color-dark-gray">${item['districtName'] === null ? '' : item['districtName']}</div>
                                    </div>
                                    <div class="tariffs__col">
                                         <div class="text-14 _color-dark-gray">${item['regionName']}</div>
                                    </div>
                                    <div class="tariffs__col">
                                         <div class="text-14 _color-dark-gray">${item['warehouseName']}</div>
                                    </div>
                                     <div class="tariffs__col">
                                        <div class="_flex _color-yellow">
                                            <div class="tariffs__icon ${(item['monday']) === true  ? '__color-yellow' : '_color-gray'}">
                                                <svg><use xlink:href="${(item['monday']) === true  ? '#checkmark' : '#minus'}"></use></svg>
                                            </div>
                                            <div class="tariffs__icon ${(item['tuesday']) === true  ? '__color-yellow' : '_color-gray'}">
                                                <svg><use xlink:href="${(item['tuesday']) === true  ? '#checkmark' : '#minus'}"></use></svg>
                                            </div>
                                            <div class="tariffs__icon ${(item['wednesday']) === true  ? '__color-yellow' : '_color-gray'}">
                                                <svg><use xlink:href="${(item['wednesday']) === true  ? '#checkmark' : '#minus'}"></use></svg>
                                            </div>
                                            <div class="tariffs__icon ${(item['thursday']) === true  ? '__color-yellow' : '_color-gray'}">
                                                <svg><use xlink:href="${(item['thursday']) === true  ? '#checkmark' : '#minus'}"></use></svg>
                                            </div>
                                            <div class="tariffs__icon ${(item['friday']) === true  ? '__color-yellow' : '_color-gray'}">
                                                <svg><use xlink:href="${(item['friday']) === true  ? '#checkmark' : '#minus'}"></use></svg>
                                            </div>
                                            <div class="tariffs__icon ${(item['saturday']) === true  ? '__color-yellow' : '_color-gray'}">
                                                <svg><use xlink:href="${(item['saturday']) === true  ? '#checkmark' : '#minus'}"></use></svg>
                                            </div>
                                        </div>
                                    </div>
                           </div>
                    `)
        });

        $localityLists.html(tariff);

        if ($localityLists.length > 0) {
            paginate($localityLists);
        }
    }

    function setCityList(data) {
        $locality.html(data);
        $locality.prepend(`<option value="0">${translates['notChosen']}</option>`)
        $locality.val(null);
    }

    function setRegionList(data) {
        $region.html(data);
        $region.prepend(`<option value="0">${translates['notChosen']}</option>`)
        $region.val(null);
    }

    GetCityWithTarif();

    function paginate(container) {
        const totalRecords = container.children().length;
        let pages = Math.ceil(totalRecords / pageSize);
        const $paginationContainer = $wrap.find('[data-pagination-slot]');
        let paginationButtons = [];
        const $prev = $paginationContainer.siblings('[data-page="prev"]');
        const $next = $paginationContainer.siblings('[data-page="next"]');

        if (currentPage === 1) {
            $prev.prop('disabled', true);
        } else {
            $prev.removeAttr('disabled');
        }
        if (currentPage === pages) {
            $next.prop('disabled', true);
        } else {
            $next.removeAttr('disabled');
        }
        if(pages > 6) {
            let pageCounter = currentPage + 5;
            if (pageCounter >= pages) {
                pageCounter = currentPage + ((currentPage - pages) * -1);
            }
            for (let i = currentPage + 5 > pages ? currentPage - (5 - (pages - currentPage)) : currentPage; i < pageCounter; i++) {
                paginationButtons.push(
                    $(`<button data-page="${i}" type="button" role="button" class="${currentPage === i ? 'tabulator-page active' : 'tabulator-page'}" ${i === currentPage ? 'disabled' : ''}>
                        ${i}
                    </button>
                    `)[0]);
            }
            paginationButtons.push(
                `<button type="button" role="button" disabled>
                    ...
                </button>`
            );
            paginationButtons.push(
                `<button data-page="${pages}" type="button" role="button" class="${currentPage === pages ? 'tabulator-page active' : 'tabulator-page'}" ${pages === currentPage ? 'disabled' : ''}>
                    ${pages}
                </button>`
            );
        } else {
            for (let i = 1; i <= pages; i++) {
                paginationButtons.push(
                    $(`<button data-page="${i}" type="button" role="button" class="${currentPage === i ? 'tabulator-page active' : 'tabulator-page'}" ${i === currentPage ? 'disabled' : ''}>
                        ${i}
                    </button>`)[0]
                );
            }
        }

        $paginationContainer.html(paginationButtons);
        container.children().addClass('_hide');
        for (let i = currentPage === 1 ? (currentPage - 1) * pageSize : ((currentPage - 1) * pageSize) + 1; i <= currentPage * pageSize; i++) {
            container.find(`[data-item="${i}"]`).removeClass('_hide');
        }
        if (pages > 0) {
            $('[data-pagination]').removeClass('_hide');
        } else {
            $('[data-pagination]').addClass('_hide');
        }
    }
}

export default function (element) {
    init(element);
}